import Error from '../../../model/Error';
import Offering from '../../../dto/offering/Offering';
import axios from 'axios';

export default class ExamOfferingRepository {

    static find(offeringId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/exam-offerings/${offeringId}`)
                .then(response => resolve(Offering.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static create(offering, clubId) {
        const data = ExamOfferingRepository.parseOfferingData(offering, 'create');
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/exam-offerings`, data)
                .then(response => resolve(response.headers['location']))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(offering) {
        const data = ExamOfferingRepository.parseOfferingData(offering, 'update');
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/exam-offerings/${offering.id}`, data)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static parseOfferingData(offering, action) {
        let data = Object.assign({}, offering);

        data.clubExams = data.clubExams.map(clubExam => clubExam.id);
        if (data.minimumAge) {
            data.minimumAge = parseInt(data.minimumAge);
        }
        if (data.maximumAge) {
            data.maximumAge = parseInt(data.maximumAge);
        }

        if (data.minimumAge === '') {
            data.minimumAge = null;
        }
        if (data.maximumAge === '') {
            data.maximumAge = null;
        }
        if (data.cancellableUntilAmount === '') {
            data.cancellableUntilAmount = null;
        }

        if (data.executionType) {
            data.executionType = data.executionType.value;
        }

        data.prices = (data.prices || []).map(price => {
            return {
                'clubFeeId': (price.clubFee && price.clubFee.id ? String(price.clubFee.id) : null),
                'departmentId': (price.department ? parseInt(price.department) : null),
                'divergentAmount': price.divergentAmount,
                'teamId': (price.team ? parseInt(price.team) : null),
                'type': (price.type ? String(price.type) : null),
            };
        });

        if (data.sport) {
            data.sportId = data.sport.id;
        }
        delete data.sport;

        if (data.fields) {
            data.fieldIds = data.fields.map(field => field.id);
        }
        delete data.fields;

        if (data.departments) {
            data.bookableDepartmentIds = data.departments.map(department => department.id);
        }
        delete data.departments;

        if (data.teams) {
            data.bookableTeamIds = data.teams.map(team => team.id);
        }
        delete data.teams;

        if (data.instructors) {
            data.instructorIds = data.instructors.map(instructor => instructor.id);
        }
        delete data.instructors;

        if (data.salesListOfferingItems) {
            if (action === 'update') {
                data.salesListOfferingItems = data.salesListOfferingItems.map(item => {
                    return {
                        offeringId: offering.id,
                        clubFeeId: item.id,
                    }
                });
            } else if (action === 'create') {
                data.salesListOfferingItems = data.salesListOfferingItems.map(item => item.id);
            }
        }

        return data;
    }
}
